import React, {useState} from 'react';
import Header from "../../../layouts/Header";
import {MdAddLocation, MdDelete, MdEditLocationAlt} from "react-icons/md";
import Loading from "../../../layouts/Loading";
import {showError, showSuccess} from "../../../utils/toastHelper";
import {useNavigate} from "react-router-dom";
import {deleteAddress, getAddresses} from "../api/AddressAPI";
import {PiMapPinPlusBold} from "react-icons/pi";


const Addresses = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [addresses, setAddresses] = React.useState([]);


    React.useEffect(() => {
        setLoading(true);
        const fetchUserInfo = async () => {
            try {
                const params = {
                    count: 15,
                    page: 1,
                    list: 1
                }
                const data = await getAddresses(params);
                setAddresses(data.data);
            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchUserInfo();

    }, []);

    const onDeleteAddress = async (id) => {
        setLoading(true)
        try {
            const result = await deleteAddress(id);
            showSuccess(result.message)
        } catch (err) {
            showError( err);
        } finally {
            const params = {
                count: 15,
                page: 1,
                list: 1
            }
            const data = await getAddresses(params);
            setAddresses(data.data);
            setLoading(false);
        }



    }

    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='  مدیریت آدرس ها ' hasBack={true} />


            <main className="container rtl mt-4 pt-4 ">

                {
                    !loading && addresses.map (address => {
                        return (
                            <div className="row address-row-alternate m-3 p-3" key={address.id}>
                                <div className="col-12 text-small-1 fw-bold">
                                    {address.title}
                                    &nbsp;

                                    <div className='fw-normal text-end text-small-1  pb-3 text-muted my-2 ltr border-bottom'>
                                        {address.address}
                                    </div>
                                </div>

                                <div className="col-6 text-small-3 pt-2 text-primary fw-bold"

                                >


                                </div>
                                <div className="col-6 text-small-3 fw-bold text-start  pt-2 text-danger"
                                     onClick={() => {
                                         onDeleteAddress(address.id)
                                     }}
                                >

                                    <MdDelete className='ms-2' />
                                    حذف آدرس
                                </div>
                            </div>
                        )
                    })
                }
                <div className="row">
                    <div className="col-12 p-2 fixed-bottom mobile-size-option">
                        <button
                            className="btn bg-primary-color text-center text-white   w-100 p-2  pe-4 border-0"
                            onClick={() => navigate('/add-address')}
                        >
                            <PiMapPinPlusBold className='mx-2 text-big-4 '/>
                            ثبت آدرس جدید

                        </button>
                    </div>
                </div>
            </main>

        </React.Fragment>
    );
};

export default Addresses;